<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Documentos</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Início',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Documentos',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnNew" type="button" color="primary" elevation="0" to="/documentos/novo">Incluir</v-btn>
                    </div>
                </div>

            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col>
                                    <v-text-field dense id="name" label="Nome" v-model="dataList.filter.name" hide-details
                                        outlined></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-autocomplete dense :items="dataset.clients" label="Caso" v-model="dataList.filter.client"
                                        item-value="id" item-text="name" outlined hide-details="auto" no-data-text="Nenhum caso encontrado">
                                    </v-autocomplete>
                                </v-col>
                                <v-col>
                                    <v-select dense :items="dataset.clientDocTypes" label="Tipo"
                                        v-model="dataList.filter.type" item-value="id" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="table-card-title">Documentos</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" 
                            :items="dataList.data"
                            :server-items-length="dataList.count" 
                            @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" 
                            :disable-sort="true" 
                            :loading="dataList.loading"
                            no-data-text="Nenhum documento foi encontrado" 
                            loading-text="Carregando dados..."
                            class="app-table hover-table" 
                            :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.type`]="{ item }">
                                {{ item.type | enum(dataset.clientDocTypes, "id", "name") }}
                            </template>

                            <template v-slot:[`item.client`]="{ item }">
                                <strong> {{ item.client && item.client.name ? item.client.name : 'N/A' }}</strong>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon :disabled="!$check('Document', 'PATCH')" @click="viewItem(item)" size="large"
                                    class="me-2">
                                    mdi-pencil-outline
                                </v-icon>
                                <v-icon :disabled="!$check('Document', 'DELETE')" @click="deleteItem(item)" size="large">
                                    mdi-delete-outline
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import clientDocTypes from "@/common/data/client-doc-types.data"

import object from "@/common/util/object"

Vue.use(VueLodash)

export default {
    name: "ClientDocList",

    data: () => ({
        dataset: {
            categories: [],
            clientDocTypes: [{ id: "", name: "Todos: " }, ...clientDocTypes],
            data: {},
            clients: [{ id: null, name: "Todos: " }]
        },
        dataList: {
            filter: {
                name: "",
                type: "",
                client: ""
            },
            headers: [
                { text: "Nome", value: "name" },
                { text: "Caso", value: "client" },
                { text: 'Tipo', value: "type" },
                { text: "Criado em", value: "created_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    created() {
        this.load();
        this.loadClients();
    },

    methods: {
        // clientPageText() {
        //     return `${this.dataList.paging.page} de ${this.dataList.paging.pages}`;
        // },

        pageChanged(page) {            
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {    
            this.dataList.options.size = size;
            this.load(true);
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        async load() {

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.size;

            try {
                const result = await axios.get('/api/admin/client-docs', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        async loadClients() {

            try {
                const result = await axios.get(`/api/clients`, { params: { start: 1, limit: 100000, search: {} } });

                const data = result.data.content.data
                
                data.sort((a, b) => a.name.localeCompare(b.name));
                
                this.dataset.clients = [{ id: "", name: "Todos: " }, ...data];

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        viewItem(item) {
            this.$router.push(`documentos/${item.id}`);
        },

        async deleteItem(item) {
            
            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir documento',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true

            try {

                const result = await axios.delete(`/api/admin/client-docs/${item.id}`)

                this.$dialog.notify.info("Documento excluído com sucesso!", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })

            } finally {
                this.dataList.loading = false;
            }
        },
    },
};
</script>